import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { isSearchPriceFilterEnabled } from '../../../utils/venuePricing';

const INITIAL_FILTERS = {
  price: false,
  vibe: false,
  eventType: false,
  attendees: false,
  moreFilters: false
};

export const useFilters = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  
  const [filters, setFilters] = useState({
    price: '',
    vibe: '',
    eventType: '',
    attendees: ''
  });
  
  const [showFilters, setShowFilters] = useState(INITIAL_FILTERS);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [showSortDropdown, setShowSortDropdown] = useState(false);
  const [sortBy, setSortBy] = useState('popularity');

  useEffect(() => {
    if (isSearchPriceFilterEnabled()) return;
    const p = searchParams.get('price');
    if (!p) return;
    const next = new URLSearchParams(searchParams);
    next.delete('price');
    setSearchParams(next, { replace: true });
  }, [searchParams, setSearchParams]);

  // Initialize filters from URL params
  useEffect(() => {
    setFilters({
      price: searchParams.get('price') || '',
      vibe: searchParams.get('vibe') || '',
      eventType: searchParams.get('eventType') || '',
      attendees: searchParams.get('attendees') || ''
    });
  }, [searchParams]);

  const handleFilterSelect = (filterType, value) => {
    const newValue = filters[filterType] === value ? '' : value;
    
    setFilters(prev => ({
      ...prev,
      [filterType]: newValue
    }));
    
    setShowFilters(prev => ({
      ...prev,
      [filterType]: false
    }));
    
    // Update URL parameters
    const newSearchParams = new URLSearchParams(searchParams);
    if (newValue) {
      newSearchParams.set(filterType, newValue);
    } else {
      newSearchParams.delete(filterType);
    }
    setSearchParams(newSearchParams);
  };

  const toggleFilterDropdown = (filterType) => {
    if (filterType === 'date') {
      // Date picker is handled separately
      return;
    }

    if (filterType === 'sort') {
      // Sort dropdown should not toggle filter dropdown state
      return;
    }
    
    setShowFilters(prev => {
      const newState = { ...INITIAL_FILTERS };
      newState[filterType] = !prev[filterType];
      return newState;
    });
    
    setShowDatePicker(false);
    setShowSortDropdown(false);
  };

  const closeAllDropdowns = () => {
    setShowFilters(INITIAL_FILTERS);
    setShowDatePicker(false);
    setShowSortDropdown(false);
  };

  return {
    filters,
    showFilters,
    showDatePicker,
    showSortDropdown,
    sortBy,
    setShowDatePicker,
    setShowSortDropdown,
    setSortBy,
    setShowFilters,
    handleFilterSelect,
    toggleFilterDropdown,
    closeAllDropdowns
  };
};

